const AUTOMATION_IDS_FOR_EMAIL_EDIT = {
  sendCodeIdentity: "edit-email-modal--send-code--button",
  verify: "edit-email-modal--verify-code--button",
  cancel: "edit-email-modal--cancel--button"
}

const AUTOMATION_IDS_FOR_PHONE_VERIFICATION = {
  verifyFlow: "login-information--verify-unverified-phone-link",
  sendCode: "verify-unverified-phone-modal--send-code-button",
  cancel: "verify-unverified-phone-modal--cancel-button",
  verify: "verify-unverified-phone-modal--verify-button",
  resendTheTextMessage: "verify-unverified-phone-modal--resend-the-text-message-button",
  callMeWithANewCode: "verify-unverified-phone-modal--call-me-with-a-new-code-button",
  textMeANewCode: "verify-unverified-phone-modal--text-me-a-new-code-button",
  resendThePhoneMessage: "verify-unverified-phone-modal--call-me-again-with-new-code-button"
}

const AUTOMATION_IDS_FOR_UNVERIFIED_PHONE_EDIT = {
  edit: "login-information--edit-unverified-phone-link",
  sendCodeIdentity: "edit-unverified-phone-modal--send-code-button",
  cancel: "edit-unverified-phone-modal--cancel-button",
  resendEmailIdentity: "edit-unverified-phone-modal--resend-the-email-message-button",
  resendText: "edit-unverified-phone-modal--new-phone-verification--resend-the-text-message-button",
  verifyIdentity: "edit-unverified-phone-modal--verify-button",
  sendCode: "edit-unverified-phone-modal--new-phone-verification--send-code-button",
  callMeWithANewCode: "edit-unverified-phone-modal--new-phone-verification--call-me-with-a-new-code-button",
  textNewCode: "edit-unverified-phone-modal--new-phone-verification--text-me-a-new-code-button",
  resendPhone: "edit-unverified-phone-modal--new-phone-verification--call-me-again-with-new-code-button",
  verify: "edit-unverified-phone-modal--new-phone-verification--verify-button"
}

const AUTOMATION_IDS_FOR_VERIFIED_PHONE_EDIT = {
  edit: "login-information--edit-verified-phone-link",
  sendCodeIdentity: "edit-verified-phone-modal--send-code-button",
  cancel:"edit-verified-phone-modal--cancel-button",
  verifyIdentity: "edit-verified-phone-modal--verify-button",
  resendEmailIdentity: "edit-verified-phone-modal--resend-the-email-message-button",
  newTextMessage:"edit-verified-phone-modal--text-me-a-new-code-button",
  newPhoneMessage: "edit-verified-phone-modal--call-me-with-a-new-code-button",
  emailNewCode: "edit-verified-phone-modal--email-me-a-new-code-button",
  resendTextIdentity: "edit-verified-phone-modal--resend-the-text-message-button",
  resendPhoneIdentity: "edit-verified-phone-modal--call-me-again-with-new-code-button",


  // Second step: Verifying the new phone.
  // Edit verified phone send code to new phone (Send Code button)
  sendCode: "edit-verified-phone-modal--new-phone-verification--send-code-button",
  // Edit verified phone send code to new phone (Verify button)
  verify:"edit-verified-phone-modal--new-phone-verification--verify-button",
  // Edit verified phone send code to new phone (Resend the text message button)
  resendText: "edit-verified-phone-modal--new-phone-verification--resend-the-text-message-button",
  // Edit verified phone send code to new phone (Call me with a new code button)
  callMeWithANewCode: "edit-verified-phone-modal--new-phone-verification--call-me-with-a-new-code-button",
  // Edit verified phone send code to new phone (Text me a new code button)
  textNewCode: "edit-verified-phone-modal--new-phone-verification--text-me-a-new-code-button",
  //Edit verified phone send code to new phone (Resend the phone message button)
  resendPhone: "edit-verified-phone-modal--new-phone-verification--call-me-again-with-new-code-button"
}


export function selectAutomationIdBasedOnComponent (flow, action, verifiedPhone= false) {

  if(flow==="phone" || flow ==="phoneEdit") {
    if(verifiedPhone) {
      return AUTOMATION_IDS_FOR_VERIFIED_PHONE_EDIT[action]
    } else {
      return AUTOMATION_IDS_FOR_UNVERIFIED_PHONE_EDIT[action]
    }
  } else if (flow==="email") {
    return AUTOMATION_IDS_FOR_EMAIL_EDIT[action]
  } else if (flow==="phoneVerification" || flow==="verifyExistingPhone") {
    return AUTOMATION_IDS_FOR_PHONE_VERIFICATION[action]
  }
}